import React, { useState } from 'react';
import { useTheme } from '../context/ThemeContext';
import '../styles/ThemePicker.css';

const ACCENTS = [
  { key: 'blue',   label: 'Blue',   swatch: '#5b7fff' },
  { key: 'green',  label: 'Green',  swatch: '#22c55e' },
  { key: 'purple', label: 'Purple', swatch: '#a78bfa' },
  { key: 'rose',   label: 'Rose',   swatch: '#fb7185' }
];

export default function ThemePicker({ scope = 'dashboard' }) {
  const { dashboardTheme, adminTheme, setDashboardTheme, setAdminTheme } = useTheme();
  const theme = scope === 'admin' ? adminTheme : dashboardTheme;
  const setTheme = scope === 'admin' ? setAdminTheme : setDashboardTheme;
  const [saving, setSaving] = useState(false);

  const handleMode = async (mode) => {
    if (mode === theme.mode || saving) return;
    setSaving(true);
    try { await setTheme({ mode }); } finally { setSaving(false); }
  };

  const handleAccent = async (accent) => {
    if (accent === theme.accent || saving) return;
    setSaving(true);
    try { await setTheme({ accent }); } finally { setSaving(false); }
  };

  return (
    <div className={`theme-picker theme-picker--${scope}`}>
      <div className="theme-picker-row">
        <span className="theme-picker-label">Mode</span>
        <div className="theme-picker-modes">
          <button
            type="button"
            className={theme.mode === 'light' ? 'tp-mode-btn active' : 'tp-mode-btn'}
            onClick={() => handleMode('light')}
            disabled={saving}
          >
            ☀️ Light
          </button>
          <button
            type="button"
            className={theme.mode === 'dark' ? 'tp-mode-btn active' : 'tp-mode-btn'}
            onClick={() => handleMode('dark')}
            disabled={saving}
          >
            🌙 Dark
          </button>
        </div>
      </div>

      <div className="theme-picker-row">
        <span className="theme-picker-label">Accent</span>
        <div className="theme-picker-swatches">
          {ACCENTS.map(a => (
            <button
              key={a.key}
              type="button"
              title={a.label}
              aria-label={a.label}
              className={theme.accent === a.key ? 'tp-swatch active' : 'tp-swatch'}
              style={{ background: a.swatch }}
              onClick={() => handleAccent(a.key)}
              disabled={saving}
            />
          ))}
        </div>
      </div>
    </div>
  );
}
